import React, { useState, useEffect } from "react";
import "./index.scss";
import { Button, Modal, Tooltip } from "antd";
import { useHistory,useLocation } from "react-router-dom";
import { moduleList } from "../../../utils/api";
import {
  general_module_type,
  general_classification_type,
} from "../../../utils/dictionary";
function Customized() {
  const language = localStorage.getItem("i18nextLng"); // 语言
  const history = useHistory();
  const location = useLocation();
  const [moduleCode, setModuleCode] = useState(
    language === "zh" ? "HL_successStories" : "HL_successStories_en"
  );
  const [allName, setAllName] = useState(language === "zh" ? "全部" : "All");

  const [moduleType, setModuleType] = useState("");
  const [classification, setClassification] = useState("");
  const [dataList, setDataList] = useState([]);
  const [activeInfo, setActiveInfo] = useState(null);
    const scrollToAnchorCustomiz = () => {
    const anchorElement = document.getElementById("contentId");
    if (anchorElement) {
      anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  };
   useEffect(() => {
    const timer = setTimeout(() => {
      getPages();
    }, 100);  // 延迟 500ms

    return () => clearTimeout(timer); 
  }, [moduleType, classification]);  
  // useEffect(async () => {
  //   getPages();
  // }, [moduleType, classification]);
  useEffect(() => {
      if (location.state|| location.state === '0') {
        const { activePoint } = location.state;
        if (activePoint==='0' || activePoint != undefined){
          console.log("activePoint", activePoint);
          setModuleType(activePoint)
          scrollToAnchorCustomiz()
        }
      }
    }, [location.state]);
  const getPages = async () => {
    let opt = {
      websiteName: "惠联官网",
      websiteCode: "HUILIAN",
      moduleCode: moduleCode,
      moduleType:general_module_type[moduleCode][moduleType]||moduleType,
      codeBak: classification,
      pageIndex: 0,
      pageSize: 20,
    };
    let data = await moduleList(opt);
    let lists = [];
    for (let i = 0; i < data.data.pageContent.length; i++) {
      let obj = JSON.parse(data.data.pageContent[i].moduleValue);
      lists.push({
        ...data.data.pageContent[i],
        ...obj,
      });
    }
    setDataList(lists.filter(item => item.id !== 26));
  };
  const handleCancel = () => {
    setActiveInfo(null);
  };
  return (
    <div className="casesListSerCon">
      <div className="casesListSerCon_con">
        <div className="casesListSerCon_top">
          <div className="top_list">
            <div
              className={moduleType === "" ? "top_list_active" : ""}
              onClick={() => {
                setModuleType("");
              }}
            >
              {allName}
            </div>
            {general_module_type[moduleCode].map((item, index) => {
              return (
                <div
                  className={moduleType === index ? "top_list_active" : ""}
                  key={index}
                  onClick={() => {
                    setModuleType(index);
                  }}
                >
                  {item}
                </div>
              );
            })}
          </div>
          <div className="top_list">
            <div
              className={classification === "" ? "top_list_active" : ""}
              onClick={() => {
                setClassification("");
              }}
            >
              {allName}
            </div>
            {general_classification_type[moduleCode].map((item, index) => {
              return (
                <div
                  className={classification === item ? "top_list_active" : ""}
                  key={index}
                  onClick={() => {
                    setClassification(item);
                  }}
                >
                  {item}
                </div>
              );
            })}
          </div>
        </div>
        <div className="casesListSerCon_Bottom">
          {dataList.map((item, index) => {
            return (
              <div
                className={`bottom_con`}
                key={index}
                onClick={() => {
                  console.log({
                    ...item,
                    moduleValue: JSON.stringify(item.moduleValue),
                  });

                  setActiveInfo({
                    ...item,
                    moduleValue: JSON.stringify(item.moduleValue),
                  });
                }}
              >
                <div className="bottom_top_img">
                  <img src={item.imgs} alt="" />
                </div>
                <div className="bottom_bottom">
                  <Tooltip title={item.title}>
                    <div className="bottom_tit">{item.title}</div>
                  </Tooltip>
                  <div className="bottom_moduleType">{item.moduleType}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        visible={activeInfo}
        footer={null}
        width={1000}
        onCancel={() => handleCancel()}
      >
        <div className="casesList_con">
          <img style={{ width: "100%" }} src={activeInfo?.imgs} />
          <div className="casesList_li">
            <h3 className="casesList_tit">{activeInfo?.title}</h3>
            <div className="casesList_label_con">
              <div className="casesList_label_success">
                {activeInfo?.codeBak}
              </div>
            </div>
          </div>
          <div dangerouslySetInnerHTML={{ __html: activeInfo?.context }}></div>
        </div>
      </Modal>
    </div>
  );
}

export default Customized;
